import { z } from 'zod';
export const USDT_DECIMALS = 6;
export const WALLET_MIN_TOPUP_MICRO_USDT = 20_000_000;
export const WalletBalanceResponse = z.object({
    balanceMicroUsdt: z.number().int().nonnegative(),
    balanceUsdt: z.string().regex(/^-?\d+\.\d{6}$/),
    currency: z.literal('USDT'),
});
// All ledger types written by any code path. Keep this in sync with what
// the writers emit:
//   - 'topup'         — paid invoice credited (payments.ts creditEsim)
//   - 'topup-refund'  — admin or auto reverse (negative amount)
//   - 'usage'         — Venta usage cron debit (negative amount, country-tagged)
//   - 'promo-bonus'   — promo redemption credit
//   - 'refund'        — legacy alias kept for back-compat
//   - 'esim-debit'    — legacy
//   - 'adjustment'    — manual operator adjustment
//
// Bug fix 2026-05-06: enum was missing 'usage' / 'topup-refund' /
// 'promo-bonus', so /api/me/history threw 500 on Zod parse the moment
// the venta-sync cron started writing usage rows. Audit ref: customer
// dashboard "Couldn't load history: HTTP 500".
export const LedgerEntryType = z.enum([
    'topup',
    'topup-refund',
    'usage',
    'promo-bonus',
    'refund',
    'esim-debit',
    'adjustment',
]);
export const LedgerEntry = z.object({
    id: z.string(),
    walletId: z.string(),
    /** Per-eSIM ledger linkage. Frontend uses this to render eSIM
     * identifier (MSISDN / displayId) in the consolidated history view.
     * Optional for backwards compatibility with rare adjustment rows
     * that aren't tied to a specific eSIM. */
    esimId: z.string().nullable().optional(),
    type: LedgerEntryType,
    amountMicroUsdt: z.number().int(),
    // Balance can in theory go slightly negative if a usage debit lands
    // before the topup ledger row catches up, or in race-conditions on
    // refund. Drop the nonnegative constraint — parse should never throw
    // because the data is correct, just not strictly nonnegative.
    balanceAfterMicroUsdt: z.number().int(),
    refType: z.string().nullable(),
    refId: z.string().nullable(),
    countryCode: z.string().nullable().optional(),
    notes: z.string().optional(),
    createdAt: z.string(),
});
export const LedgerHistoryResponse = z.object({
    entries: z.array(LedgerEntry),
    nextCursor: z.string().nullable(),
});
